export const Logo = ({ light = false, compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="site-logo">
    <picture>
      <source srcSet="/ada-logo.webp" type="image/webp" />
      <img src="/ada-logo.png" alt="Ada Özel Güvenlik Eğitim Kurumu logosu" width="40" height="50" className="h-[50px] w-auto" />
    </picture>
    {!compact && (
      <span className="leading-none">
        <span className={`block font-display font-black text-lg tracking-tight ${light ? "text-white" : "text-zinc-950"}`}>ADA</span>
        <span className={`block text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-zinc-400" : "text-zinc-500"}`}>Özel Güvenlik Eğitim Kurumu</span>
      </span>
    )}
  </span>
);
